import { Link } from "react-router-dom";
import {
  formatLeadStatus,
  formatLeadTypeToIcon,
  formatPhoneNumber,
  getLeadStatusColor,
} from "../utils/displayFormatters";

// "3h ago", "2d ago". Lead list rows carry updated_at as the last activity time.
const timeSince = (iso) => {
  if (!iso) return "";
  const minutes = Math.max(0, Math.floor((Date.now() - new Date(iso)) / 60000));
  if (minutes < 60) return `${minutes}m ago`;
  if (minutes < 60 * 24) return `${Math.floor(minutes / 60)}h ago`;
  return `${Math.floor(minutes / (60 * 24))}d ago`;
};

// One lead on a phone. The whole card is the link. `badges` holds the
// Waiting reply and Needs callback badges, which LeadList renders.
const LeadCard = ({ lead, badges, isSelected }) => {
  const hasName = lead.first_name?.trim() || lead.last_name?.trim();
  const name = hasName
    ? `${lead.first_name || ""} ${lead.last_name || ""}`.trim()
    : formatPhoneNumber(lead.phone);
  return (
    <Link
      to={`/leads/${lead.id}`}
      state={{ fromList: true }}
      data-testid="lead-card"
      className={`block bg-white shadow-sm rounded-lg p-4 border border-border ${
        isSelected ? "border-l-4 border-teal-600" : ""
      }`}
    >
      <div className="flex justify-between items-start gap-2">
        <span className="ph-mask font-medium text-primary flex items-center gap-2 min-w-0">
          <span>{formatLeadTypeToIcon(lead.type)}</span>
          <span className={lead.is_read_by_user ? "" : "font-bold"}>{name}</span>
        </span>
        <span
          className={`px-3 py-1 inline-flex items-center justify-center text-xs font-medium rounded-full whitespace-nowrap ${getLeadStatusColor(lead.status)}`}
        >
          {formatLeadStatus(lead.status).label}
        </span>
      </div>
      <div className="mt-2 flex justify-between text-sm text-gray-700">
        <span>{lead.source_display}</span>
        <span>{timeSince(lead.updated_at)}</span>
      </div>
      <div className="mt-2 flex flex-wrap gap-2 empty:hidden">{badges}</div>
    </Link>
  );
};

export default LeadCard;
